<template>
  <section class="short-deck-purchase">
    <header>
      <h1 class="page-header">Purchase Short Deck Hit Calculator</h1>
    </header>
    <errors-alert
      v-bind:errors="errorsFromBackend"
      v-on:clear="clearAlert()"
    />
    <img src="/static/pages/short-deck-hit-calculator.png" />
    <section class="alert alert-info">
      <section v-if="daysLeftOnFreeTrial > 0">
        <p>You have <strong>{{ daysLeftOnFreeTrial }} days left</strong> on your 14 day free trial. You can certainly wait for your free trial to end before purchasing, but if you'd like to purchase now, fill out and submit the form below.</p>
      </section>
      <p>Any questions? Don't hesitate to reach out: <a href="mailto:contact@sixplusholdem.com">contact@sixplusholdem.com</a>.</p>
    </section>
    <hr>
    <section class="form-group">
      <label>
        Credit card number
        <card-number
          ref="cardNumber"
          class="stripe-element card-number form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="number = $event.complete"
        />
      </label>
    </section>
    <section class="form-group">
      <label>
        Expiration date
        <card-expiry
          ref="cardExpiry"
          class="stripe-element card-expiry form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="expiry = $event.complete"
        />
      </label>
    </section>
    <section class="form-group">
      <label>
        CVC
        <card-cvc
          ref="cardCvc"
          class="stripe-element card-cvc form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="cvc = $event.complete"
        />
      </label>
    </section>
    <button
      class="pay-with-stripe btn btn-primary btn-block btn-lg"
      v-bind:disabled="!complete || purchasing"
      v-on:click="purchase()"
    >
      {{ purchaseText }}
    </button>
  </section>
</template>

<script>
import ErrorsAlert from '@/components/utilities/errors-alert';
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus';
import utilities from '@/services/utilities/utilities';

export default {
  name: 'short-deck-purchase',
  components: {
    'errors-alert': ErrorsAlert,
    'card-number': CardNumber,
    'card-expiry': CardExpiry,
    'card-cvc': CardCvc,
  },
  data: function () {
    return {
      stripeConsumerKey: process.env.STRIPE_CONSUMER_KEY,
      options: {},
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      purchasing: false,
      errorsFromBackend: [],
    };
  },
  computed: {
    daysLeftOnFreeTrial: function () {
      return this.$store.getters['account/daysLeftOnFreeTrial'];
    },
    purchaseText: function () {
      if (this.purchasing) {
        return 'Purchasing...';
      }

      return `Purchase the Short Deck Hit Calculator for $150`;
    },
  },
  watch: {
    number: function () {
      this.update();
    },
    expiry: function () {
      this.update();
    },
    cvc: function () {
      this.update();
    },
  },
  beforeRouteLeave: function (to, from, next) {
    this.$destroy(); // because of stripe issue
    next();
  },
  methods: {
    update: function () {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    purchase: function () {
      let self = this;

      self.purchasing = true;
      createToken()
        .then(function (result) {
          if (result.error) {
            self.purchasing = false;
            self.errorsFromBackend.push(result.error.message);
          }

          else {
            self.$http
              .patch(`${process.env.BASE_API_URL}/user/purchase-short-deck`, {
                token: result.token.id,
              })
              .then(function () {
                self.$store.commit('account/purchasePPT', 'short deck');
                self.purchasing = false;
                alert(`Successfully purchased the short deck hit calculator!`);
                self.$router.push({ path: '/account' });
              })
              .catch(function (e) {
                self.purchasing = false;
                utilities.general.handleNetworkError(e);
              })
              .then(function () {
                if (process.env.NODE_ENV === 'production') {
                  $FPROM.trackSignup({
                    email: self.$store.state.account.user.email,
                  }, function() {
                    console.log('Callback received!');
                  });
                  rdt('track', 'Purchase');
                  // self.gtagReportConversion();
                  self.microsoftReportConversion();
                }
              })
              .catch(function () {
                console.log('Error with the conversion tracking for ads.');
              })
            ;
          }
        })
        .catch(function (e) {
          self.purchasing = false;
          utilities.general.handleNetworkError(e);
        })
      ;
    },
    gtagReportConversion: function (url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-714944788/w5PhCJ3ozqgBEJTi9NQC',
          'transaction_id': '',
          'event_callback': callback
      });
      return false;
    },
    microsoftReportConversion: function () {
      let eventValue = 150;

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'Subscribe', { event_value: eventValue });
    },
    clearAlert: function () {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    },
  },
};
</script>

<style lang="scss" scoped>
  .short-deck-purchase {
    font-size: 18px;
  }

  button {
    font-size: 18px;
  }

  .credit-card-inputs.complete {
    border: 2px solid green;
  }

  label {
    width: 100%;
  }

  .form-control {
    width: 100%;
    height: 40px;
  }

  img {
    max-width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/short-deck-purchase.vue